import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import { ContactFilterConditionInterface } from '../../types/contact-filter-interface';
import { getFilterApi } from '../../utils/get-filter-api';
import { REMOVED_CONTACTS_API } from '../api/removed-contacts-api';
import { ContactRemovedApiInterface } from '../types/contact-removed-interface';
interface UseContactsRemovedInterface extends SwrPaginationInterface {
  conditions: ContactFilterConditionInterface[];
}
export function useContactsRemovedList(t0) {
  const $ = _c(11);
  const {
    limit,
    pagination,
    conditions
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== conditions) {
    t2 = getFilterApi(conditions);
    $[1] = conditions;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const filterApi = t2;
  let t3;
  if ($[3] !== filterApi || $[4] !== limit || $[5] !== pagination || $[6] !== user) {
    t3 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${REMOVED_CONTACTS_API}/list?pagination[limit]=${limit}${filterApi}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${REMOVED_CONTACTS_API}/list?${getPaginationQueryString({
            limit,
            pagination
          })}${filterApi}`;
        }
      }
      return null;
    };
    $[3] = filterApi;
    $[4] = limit;
    $[5] = pagination;
    $[6] = user;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: removedContacts,
    abort
  } = useControlledSwr(t3, fetcher);
  let t4;
  if ($[8] !== abort || $[9] !== removedContacts) {
    t4 = {
      removedContacts,
      abort
    };
    $[8] = abort;
    $[9] = removedContacts;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}